import { BUNDLE_SUITE_PRO_FOR_TEAMS, BUNDLE_SUITE_FOR_TEAMS, BUNDLE_SUITE_PRO_FOR_INDIVIDUAL, BUNDLE_SUITE_FOR_INDIVIDUAL } from 'Components/viewer/ui/constants/event.constants.share';

export const INDIVIDUAL_BUNDLE_PRODUCT_LIST = [
  {
    name: 'PDF Editor Suite Pro for Individuals 2023',
    show_name: 'PDF Editor Suite Pro<br/>for Individuals 2023',
    sku: 'FPEPPI',
    app_code: 'pdf_editor_ps_individual_pro',
    ga_event: BUNDLE_SUITE_PRO_FOR_INDIVIDUAL,
  }, {
    name: 'PDF Editor Suite for Individuals 2023',
    show_name: 'PDF Editor Suite<br/>for Individuals 2023',
    sku: 'FPEPI',
    app_code_win: 'pdf_editor_ps_individual_win',
    app_code_mac: 'pdf_editor_ps_individual_mac',
    ga_event: BUNDLE_SUITE_FOR_INDIVIDUAL,
  },
];

export const ENTERPRISE_BUNDLE_PRODUCT_LIST = [
  {
    name: 'PDF Editor Suite Pro for Teams 2023',
    show_name: 'PDF Editor Suite Pro<br/>for Teams 2023',
    sku: 'FPEPPT',
    app_code: 'pdf_editor_ps_business_pro',
    ga_event: BUNDLE_SUITE_PRO_FOR_TEAMS,
  }, {
    name: 'PDF Editor Suite for Teams 2023',
    show_name: 'PDF Editor Suite<br/>for Teams 2023',
    sku: 'FPEPT',
    app_code_win: 'pdf_editor_ps_business_win',
    app_code_mac: 'pdf_editor_ps_business_mac',
    ga_event: BUNDLE_SUITE_FOR_TEAMS,
  },
];

export const EDU_BUNDLE_PRODUCT_LIST = [
  {
    name: 'PDF Editor Suite Pro for Education 2023',
    show_name: 'PDF Editor Suite Pro<br/>for Education 2023',
    sku: 'FPEPPE',
    app_code: 'pdf_editor_ps_education_pro',
    ga_event: '',
  }, {
    name: 'PDF Editor Cloud for Education 2023',
    show_name: 'PDF Editor Cloud<br/>for Education 2023',
    sku: 'FPECE',
    app_code: 'pdf_editor_cloud_education',
    ga_event: '',
  },
];

export const BUNDLE_PRODUCT_CODE = [
  'pdf_editor_ps_education_pro',
  'pdf_editor_cloud_education',
  'pdf_editor_ps_business_win',
  'pdf_editor_ps_business_mac',
  'pdf_editor_ps_business_pro',
  'pdf_editor_ps_individual_mac',
  'pdf_editor_ps_individual_win',
  'pdf_editor_ps_individual_pro',
];
export const PRODUCT_INCLUDE_CLOUD = [
  'phantom_ga_education_pro_plus',
  'pdfeditor_pro_plus_win',
  'pdfeditor_pro_plus_mac',
];

